import {AnimatePresence, motion} from 'framer-motion'
import React from 'react'

import {tokens} from '@pleo-io/telescope'

import {LoginScreen, useLoginLocationState} from '@product-web-features/sca/login/login.helpers'

import {EmailScreen} from './components/email-screen'
import {EmailValidationScreen} from './components/email-validation-screen'
import {OtpValidationForEmailVerificationScreenV2} from './components/otp-screen-v2'
import {PasscodeScreenV2} from './components/passcode-screen-v2'

/**
 * Login Flow
 * This will support both legacy and the new 2FA way of doing things
 * (Account has verified phone number) => (1) Ask for passcode => (2) Request Otp (one time password) => (3) Gain Access
 *
 */
export function LoginFlow() {
    const {
        state: {screen},
    } = useLoginLocationState()

    const elementV2 = React.useMemo(() => {
        let el
        switch (screen) {
            case LoginScreen.PASSCODE:
                el = <PasscodeScreenV2 />
                break
            case LoginScreen.OTP_EMAIL_VALIDATION:
                el = <OtpValidationForEmailVerificationScreenV2 />
                break
            case LoginScreen.EMAIL_VALIDATION:
                el = <EmailValidationScreen />
                break
            default:
                el = <EmailScreen />
        }

        return el
    }, [screen])

    return (
        <AnimatePresence initial={false}>
            <motion.div
                key={screen ?? undefined}
                initial={screen ? screenAnimations.initial : undefined}
                animate={screenAnimations.animate}
                exit="initial"
            >
                {elementV2}
            </motion.div>
        </AnimatePresence>
    )
}

const screenAnimations = {
    initial: {
        x: 0,
        opacity: 0,
        transition: {
            opacity: tokens.slowOut,
        },
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: {
            opacity: tokens.smoothIn,
        },
    },
}
